import { combineReducers } from 'redux'
import activities from './activities/reducer'
import properties from './properties/reducer'
import savings from './savings/reducer'
import debts from './debts/reducer'
import income from './income/reducer'
import lifestyle_expenses from './lifestyle/reducer'
import faq from './faq/reducer'

export const thisyear = combineReducers({
	activities,
	properties,
	savings,
	debts,
	income,
	lifestyle_expenses,
	faq
})
